module.exports = __webpack_public_path__ + "static/media/fly0087.e8990fae.webp";